import types from "./types";

/***
 * /////////////////////////////////////////
 * REDUCERS (リデューサー)
 * -------------------
 *
 * すべてのリアクトのマネージャーアカウントの一時的なデータが保存される領域。
 * アプリケーションのどこでもデータを使用することができます。
 *
 * Reducerイベントは、ステートへのセッター命令のみを **実行すべき** です。
 *
 * このReducerのステートは、/src/state/ducks/index.jsに設定されているrequestsグループに束縛されています。
 * //////////////////////////////////////////
 */
export const requestState = {
    requestListLoading: true,
    requestListError: {},
    requestList: {},

    searchFormInformation: {
        ebis_client_name: null,
        application_at_from: null,
        application_at_to: null,
        status: null,
        type: null,
        application_complete_at_from: null,
        application_complete_at_to: null
    },

    requestDetailLoading: true,
    requestDetailError: {},
    requestDetail: {},

    requestQuoteLoading: true,
    requestQuoteError: {},
    requestQuote: {},

    requestStartUpInformationStep: 0,
    updateHasCheckedRequiresOptionInformation: false,
    updateRequiresOptionInformation: false,
    updateOptionStep: 0,
    requestStartUpInformation: {
        ebis_log_id: "",
        ebis_client_name: "",
        ebis_host_names: [""],
        industry_type: "",
        business_model: "",
        official_company_name: ""
    },

    additionalOptionInformation: null,
    formattedAdditionalOptionInformation: null,

    additionalOptionValidation: null,

    ebisAccountConfirmedLoading: false,
    ebisAccountConfirmedError: {},

    changePlanApprovedLoading: false,
    changePlanApprovedError: {},

    hasScrolledTermsToBottom: false,
    requestApplyAcceptTerms: false,
    termsAndConditionsIsOpen: false,

    pdfIsLoading: false,
    pdfData: null,
    pdfError: {},

    isCancelConfirmationOpen: false,
    cancelRequestLoading: false,
    cancelRequestError: {},

    isCancelConfirmedModalOpen: false,
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export default function requestReducer(state = requestState, action) {
    switch (action.type) {
        case types.REQUESTS_LOADING:
            return {
                ...state,
                requestListLoading: state.requestListLoading = true,
                requestListError: state.requestListError = {},
                requestList: state.requestList = {}
            }
        case types.REQUESTS_SUCCESS:
            return {
                ...state,
                requestListLoading: state.requestListLoading = false,
                requestListError: state.requestListError = {},
                requestList: state.requestList = action.payload.requests
            }
        case types.REQUESTS_FAILED:
            return {
                ...state,
                requestListLoading: state.requestListLoading = false,
                requestListError: state.requestListError = action.payload.error,
                requestList: state.requestList = {}
            }
        case types.REQUESTS_SEARCH_SUCCESS:
            return {
                ...state,
                requestListLoading: state.requestListLoading = false,
                requestListError: state.requestListError = {},
                requestList: state.requestList = action.payload.requests
            }
        case types.EDIT_SEARCH_FORM:
            return {
                ...state,
                searchFormInformation: state.searchFormInformation = action.payload.form
            }
        case types.CONTRACT_NAME_SEND_TO_FORM: {
            return {
                ...state,
                searchFormInformation: state.searchFormInformation = {
                    ...state.searchFormInformation,
                    ebis_client_name: state.searchFormInformation.ebis_client_name = action.payload.account_name
                }
            }
        }
        /*********
         * お申込詳細
         ********/
        case types.REQUESTS_DETAIL_LOAD:
            return {
                ...state,
                isCancelConfirmedModalOpen: state.isCancelConfirmedModalOpen = false
            }
        case types.REQUESTS_DETAIL_LOAD_LOADING:
            return {
                ...state,
                requestDetailLoading: state.requestDetailLoading = true,
                requestDetailError: state.requestDetailError = {},
                requestDetail: state.requestDetail = {}
            }
        case types.REQUESTS_DETAIL_LOAD_SUCCESS:
            return {
                ...state,
                requestDetailLoading: state.requestDetailLoading = false,
                requestDetailError: state.requestDetailError = {},
                requestDetail: state.requestDetail = action.payload.request_detail
            }
        case types.REQUESTS_DETAIL_LOAD_FAILURE:
            return {
                ...state,
                requestDetailLoading: state.requestDetailLoading = false,
                requestDetailError: state.requestDetailError = action.payload.error,
                requestDetail: state.requestDetail = {}
            }
        /*********
         * お申込詳細
         *********/
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_LOADING:
            return {
                ...state,
                requestQuoteLoading: state.requestQuoteLoading = true,
                requestQuoteError: state.requestQuoteError = {},
                requestQuote: state.requestQuote = {}
            }
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_SUCCESS:
            return {
                ...state,
                requestQuoteLoading: state.requestQuoteLoading = false,
                requestQuoteError: state.requestQuoteError = {},
                requestQuote: state.requestQuote = action.payload.quote
            }
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_FAILURE:
            return {
                ...state,
                requestQuoteLoading: state.requestQuoteLoading = false,
                requestQuoteError: state.requestQuoteError = action.payload.error,
                requestQuote: state.requestQuote = {}
            }

        /**
         * 申請
         */
        case types.SETTING_EBIS_ACCOUNT_OPTION_FORM_INPUT_SETTING:
            return {
                ...state,
                updateHasCheckedRequiresOptionInformation: state.updateHasCheckedRequiresOptionInformation = true,
                updateRequiresOptionInformation: state.updateRequiresOptionInformation = true,
                additionalOptionInformation: state.additionalOptionInformation = action.payload.initialFields,
                additionalOptionValidation: state.additionalOptionValidation = action.payload.validation
            }
        case types.SETTING_EBIS_OPTION_NO_UPDATE_NEEDED:
            return {
                ...state,
                updateHasCheckedRequiresOptionInformation: state.updateHasCheckedRequiresOptionInformation = true,
                updateRequiresOptionInformation: state.updateRequiresOptionInformation = false,
            }
        case types.RESET_FORM:
            return {
                ...state,
                requestStartUpInformation: state.requestStartUpInformation = {
                    ebis_log_id: "",
                    ebis_client_name: "",
                    ebis_host_names: [""],
                    industry_type: "",
                    business_model: "",
                    official_company_name: ""
                },
                updateHasCheckedRequiresOptionInformation: state.updateHasCheckedRequiresOptionInformation = false,
                updateRequiresOptionInformation: state.updateRequiresOptionInformation = false,
                updateOptionStep: state.updateOptionStep = 0,
                additionalOptionInformation: state.additionalOptionInformation = null,
                formattedAdditionalOptionInformation: state.formattedAdditionalOptionInformation = null,
                additionalOptionValidation: state.additionalOptionValidation = null,

                requestStartUpInformationStep: state.requestStartUpInformationStep = 0,
                requestApplyAcceptTerms: state.requestApplyAcceptTerms = false,
                hasScrolledTermsToBottom: state.hasScrolledTermsToBottom = false
            }
        case types.SETTING_EBIS_ACCOUNT_INFORMATION_INPUT:
            return {
                ...state,
                requestStartUpInformation: state.requestStartUpInformation = action.payload.requestStartUpInformation,
                requestStartUpInformationStep: state.requestStartUpInformationStep = action.payload.stepBy,
                requestApplyAcceptTerms: state.requestApplyAcceptTerms = false,
                hasScrolledTermsToBottom: state.hasScrolledTermsToBottom = false
            }
        case types.SETTING_ADDITIONAL_OPTION_INPUT:
            return {
                ...state,
                additionalOptionInformation: state.additionalOptionInformation = action.payload.additionalFormInformation,
                formattedAdditionalOptionInformation: state.formattedAdditionalOptionInformation = action.payload.formattedAdditionalForm,
                requestStartUpInformationStep: state.requestStartUpInformationStep = 2,
                requestApplyAcceptTerms: state.requestApplyAcceptTerms = false,
                hasScrolledTermsToBottom: state.hasScrolledTermsToBottom = false,
            }
        case types.UPDATE_SETTING_ADDITIONAL_OPTION_INPUT:
            return {
                ...state,
                additionalOptionInformation: state.additionalOptionInformation = action.payload.additionalFormInformation,
                formattedAdditionalOptionInformation: state.formattedAdditionalOptionInformation = action.payload.formattedAdditionalForm,
                updateOptionStep: state.updateOptionStep = 1,
                requestApplyAcceptTerms: state.requestApplyAcceptTerms = false,
                hasScrolledTermsToBottom: state.hasScrolledTermsToBottom = false,
            }
        case types.BACK_TO_UPDATE_SETTING_ADDITIONAL_OPTION_INPUT:
            return {
                ...state,
                updateOptionStep: state.updateOptionStep = 0
            }
        /****
         * 本申込フォーム送信
         ****/
        case types.SETTING_EBIS_ACCOUNT_INFORMATION_CONFIRMED_LOADING:
            return {
                ...state,
                ebisAccountConfirmedLoading: state.ebisAccountConfirmedLoading = true,
                ebisAccountConfirmedError: state.ebisAccountConfirmedError = {}
            }
        case types.SETTING_EBIS_ACCOUNT_INFORMATION_CONFIRMED_SUCCESS:
            return {
                ...state,
                ebisAccountConfirmedLoading: state.ebisAccountConfirmedLoading = false,
                requestStartUpInformationStep: state.requestStartUpInformationStep = 3
            }
        case types.SETTING_EBIS_ACCOUNT_INFORMATION_CONFIRMED_FAILURE:
            return {
                ...state,
                ebisAccountConfirmedLoading: state.ebisAccountConfirmedLoading = false,
                ebisAccountConfirmedError: state.ebisAccountConfirmedError = action.payload.error
            }
        /****
         * 本申込フォーム送信 (契約変更のみ）
         ****/
        case types.CONTRACT_CHANGE_QUOTE_APPROVED_REQUEST_LOADING:
            return {
                ...state,
                changePlanApprovedLoading: state.changePlanApprovedLoading = true,
                changePlanApprovedError: state.changePlanApprovedError = {}
            }
        case types.CONTRACT_CHANGE_QUOTE_APPROVED_REQUEST_SUCCESS:
            return {
                ...state,
                changePlanApprovedLoading: state.changePlanApprovedLoading = false,
                requestStartUpInformationStep: state.requestStartUpInformationStep = 1
            }
        case types.CONTRACT_CHANGE_QUOTE_APPROVED_REQUEST_FAILURE:
            return {
                ...state,
                changePlanApprovedLoading: state.changePlanApprovedLoading = false,
                changePlanApprovedError: state.changePlanApprovedError = action.payload.error
            }
        /***
         *
         */
        case types.SETTING_EBIS_ACCOUNT_BACK_BUTTON:
            return {
                ...state,
                requestStartUpInformationStep: state.requestStartUpInformationStep -= action.payload.stepsBackBy
            }
        case types.SETTING_SCROLLED_TO_TERMS_BOTTOM:
            return {
                ...state,
                hasScrolledTermsToBottom: state.hasScrolledTermsToBottom = true
            }
        case types.SETTING_APPLY_TOGGLE_TERMS:
            return {
                ...state,
                requestApplyAcceptTerms: state.requestApplyAcceptTerms = !state.requestApplyAcceptTerms
            }
        case types.SETTING_APPLY_INFORMATION_CONFIRMED:
            return {
                ...state,
                requestStartUpInformationStep: state.requestStartUpInformationStep = 1
            }
        case types.CLOSE_TERMS_AND_CONDITIONS_MODAL:
            return {
                ...state,
                termsAndConditionsIsOpen: state.termsAndConditionsIsOpen = false
            }
        case types.OPEN_TERMS_AND_CONDITIONS_MODAL:
            return {
                ...state,
                termsAndConditionsIsOpen: state.termsAndConditionsIsOpen = true
            }
        /****
         * 見積もりダウンロードエヴェント
         ****/
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_PDF_LOADING:
            return {
                ...state,
                pdfIsLoading: state.pdfIsLoading = true,
                pdfError: state.pdfError = {},
                pdfData: state.pdfData = null
            }
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_PDF_SUCCESS:
            return {
                ...state,
                pdfIsLoading: state.pdfIsLoading = false,
                pdfData: state.pdfData = action.payload.binaryFileData
            }
        case types.REQUESTS_DETAIL_QUOTE_DETAIL_LOAD_PDF_FAILURE:
            return {
                ...state,
                pdfIsLoading: state.pdfIsLoading = true,
                pdfError: state.pdfError = action.payload.error,
            }
        /*********
         * 申込キャンセルエベント
         *********/
        case types.REQUESTS_DETAIL_CANCEL_REQUEST_TOGGLE:
            return {
                ...state,
                isCancelConfirmationOpen: state.isCancelConfirmationOpen = action.payload.willOpen
            }
        case types.REQUESTS_DETAIL_CANCEL_REQUEST_LOADING:
            return {
                ...state,
                cancelRequestLoading: state.cancelRequestLoading = true,
                cancelRequestError: state.cancelRequestError = {},
            }
        case types.REQUESTS_DETAIL_CANCEL_REQUEST_SUCCESS:
            return {
                ...state,
                cancelRequestLoading: state.cancelRequestLoading = false,
                isCancelConfirmationOpen: state.isCancelConfirmationOpen = false,
                isCancelConfirmedModalOpen: state.isCancelConfirmedModalOpen = true
            }
        case types.REQUESTS_DETAIL_CANCEL_REQUEST_FAILURE:
            return {
                ...state,
                cancelRequestLoading: state.cancelRequestLoading = false,
                cancelRequestError: state.cancelRequestError = action.payload.error
            }
        /*********
         * アカウントIDパース処理
         *********/
        case types.REQUEST_SERVICE_CONTRACT_ID_QUERY_SUCCESS:
            return {
                ...state,
                searchFormInformation: {
                    ...state.searchFormInformation,
                    ebis_client_name: action.payload.account_name
                }
            }
        default:
            return state;
    }
}
